import calculateCartSum from '../helpers/calculateCartSum';
import { types } from '../types';

const mutations = {
  [types.SET_LOADING](state, loading) {
    const existsLoadingStatuses = state.loading;
    state.loading = { ...existsLoadingStatuses, ...loading };
  },
  [types.SET_USER_SESSION_ID](state, payload) {
    state.user.sessionId = payload;
  },
  [types.SET_SESSION_ID](state, payload) {
    state.session.id = payload;
  },
  [types.SET_THEATRE_ID](state, payload) {
    state.theatre.id = payload;
  },
  [types.SET_THEATRE](state, payload) {
    state.theatre = payload;
  },
  [types.SET_THEATRE_PAYMENT_INFO](state, payload) {
    state.setting.paymentMethods = payload.PaymentMethods;
    state.setting.enabledPayments = payload.EnabledPayments;
  },
  [types.SET_MOVIE](state, payload) {
    state.movie = payload;
  },

  // [types.SET_SESSION_PRICES](state, prices) {
  //   console.log(prices, "Prices")
  //
  //   state.session.Prices = prices
  // },
  [types.SET_SESSION](state, newSession) {
    state.session = newSession;
    state.places = newSession.Hall.Levels[0].Places;
  },
  [types.SET_BAR](state, bar) {
    state.bar = bar;
  },
  [types.SET_AUTH_TOKEN](state, authToken) {
    state.authToken = authToken;
  },

  [types.SESSION_WITHOUT_PLACES](state) {
    state.places = null;
  },

  // используется не знаю зачем
  [types.SET_ID_TOKEN](state, idToken) {
    state.idToken = idToken;
  },

  [types.SET_CITIES](state, payload) {
    state.data.cities = payload;
  },

  [types.SET_NOTIFICATIONS](state, payload) {
    state.data.notifications = JSON.parse(JSON.stringify(payload));
  },

  [types.SET_BAR_OPTION](state, payload) {
    const { name, value } = payload;

    if (state.data.barForm) state.data.barForm[name] = value;
    if (state.data.schedule) state.data.schedule[name] = value;
  },

  /* [types.SET_BAR_OPTION](state, payload) {
    const { name, value } = payload;

    state.data.schedule[name] = value;
  }, */

  [types.SET_SCHEDULE](state, filmsWithData) {
    state.data.schedule = filmsWithData;
  },

  // if product does not exist in cart then add else remove
  [types.ADD_PLACE_TO_CART](state, data) {
    state.cart.tickets.push(data.place);
    state.cart.sum += data.place.price;
    state.cart.ticketSum += data.place.price;
  },

  [types.GET_FILM_WITH_SCHEDULE](state, data) {
    state.data.filmWithSchedule = data;
  },

  [types.RESET_FILM_WITH_SCHEDULE](state) {
    state.data.filmWithSchedule = {
      Theatres: [],
    };
  },

  [types.REMOVE_PLACE_FROM_CART](state, index) {
    state.cart.sum -= state.cart.tickets[index].price;
    state.cart.ticketSum -= state.cart.tickets[index].price;
    state.cart.tickets.splice(index, 1);
  },

  // if product does not exist in cart then add else remove
  [types.ADD_BAR_TO_CART](state, data) {
    data.item.count = 1;
    state.cart.bar.push(data.item);
    state.cart.sum = Number(state.cart.sum) + Number(data.item.Price);
    state.cart.barSum = Number(state.cart.barSum) + Number(data.item.Price);
  },

  [types.ADD_TO_REMOVED_PLACES_LIST](state, place) {
    state.cart.deletedTickets.push(place);
  },

  [types.CLEAR_REMOVED_PLACES_LIST](state) {
    state.cart.deletedTickets = [];
  },

  [types.CHANGE_BAR_IN_CART](state, data) {
    state.cart.sum +=
      Number(state.cart.bar[data.index].Price) * Number(data.count);
    state.cart.barSum +=
      Number(state.cart.bar[data.index].Price) * Number(data.count);
    state.cart.bar[data.index].count += Number(data.count);
  },
  [types.REMOVE_BAR_FROM_CART](state, index) {
    state.cart.sum -= state.cart.bar[index].Price;
    state.cart.barSum -= state.cart.bar[index].Price;
    state.cart.bar[index].count = 0;
    // state.cart.bar.splice(index, 1);
  },
  [types.CLEAR_BAR_ZERO_ITEMS](state) {
    let zeroIndexes = [];
    state.cart.bar.forEach((item, index) => {
      if (item.count === 0) {
        zeroIndexes.push(index);
      }
    });
    zeroIndexes.forEach((index) => {
      state.cart.bar.splice(index, 1);
    });
  },

  [types.SET_DONATION_SIZE](state, payload) {
    state.cart.sum =
      Number(state.cart.sum) - Number(state.cart.donations) + Number(payload);
    state.cart.donations = Number(payload);
  },

  [types.SET_PROMOCODE_VALUE](state, payload) {
    state.cart.promocode = payload;
  },

  [types.ADD_ERROR_PROMOCODE](state, error) {
    state.cart.promoError = error;
  },

  [types.CLEAR_BAR](state, payload) {
    state.cart.sum -= state.cart.barSum;
    state.cart.barSum = 0;
    state.cart.bar = [];
    if (payload) state.bar = [];
    else
      state.bar = state.bar.map((barGroup) => ({
        ...barGroup,
        items: barGroup.Items.map((item) => ({ ...item, count: 0 })),
      }));
  },

  [types.ADD_ERROR](state, error) {
    state.errors.push(error);
  },

  // TODO Разобраться в необходимости этой мутации
  [types.RESET_SESSION_END_AT](state) {
    state.user.sessionEndAt = null;
  },

  [types.CLEAR_CART](state) {
    state.cart = {
      tickets: [],
      deletedTickets: [],
      bar: [],
      ticketSum: 0, // промежуточная стоимость всех билетов
      barSum: 0, // промежуточная стоимость всей продукции бара
      sum: 0, // сумма с учетом бонусов. Отправляется в платежную систему
      totalSum: 0, // общая сумма без учета бонусов
      usedBonuses: 0, // общее количество бонусов. Находится в сторе, чтоб восстановить значение после смена route
      spentBonuses: {
        bar: 0, // количество потраченных бонусов на бар
        tickets: 0, // количество потраченных бонусов на билеты
      },
      donations: '',
    };
    state.orderId = null;
  },

  [types.CLEAR_USER](state) {
    state.user = {
      sessionEndAt: null,
      sessionId: null,
      socketSessionId: null,
      ticketOrderId: null,
      barOrderId: null,
      barOrderCode: null,
      transactionId: null,
      card: {
        number: null,
        balance: null,
        id: null,
      },
      maxBonuses: 0,
      email: null,
      name: null,
      prepareOrderBefore: null,
      subscription: false,
      paymentType: 'Base',
      paymentWithBonuses: false, // Включена ли оплата бонусами (задается пользователем на странице оплаты)
      isAuthorized: false,
      createdAt: null,
      birthday: null,
      gender: null,
      phone: null,
    };
  },

  [types.CLEAR_ERRORS](state, delay = 0) {
    if (delay > 0) {
      setTimeout(() => {
        state.errors = [];
      }, delay);
    } else {
      state.errors = [];
    }
  },

  [types.SET_ORDER_ID](state, orderId) {
    const milisecInMinute = 60 * 1000;

    state.orderId = orderId;
    state.user.sessionEndAt =
      Number(new Date()) + state.theatre.SessionDuration * milisecInMinute;
  },

  [types.SET_TRANSACTION_ID](state, data) {
    state.user.transactionId = data.transactionId;
  },

  [types.SET_DATA](state, data) {
    (state.session = { ...data.session }), (state.movie = data.movie);
    state.bar = data.bar;
    state.setting = {
      freePlaces: true,
      freeCostPlaces: true,
      ...data.setting,
    };

    state.user.sessionId = data.user_session_id;
    state.widget_theatre_id = data.widget_theatre_id;

    if (!state.movie.Image) {
      state.movie.Image = '/movie-placeholder.png';
    }
  },

  //tmp get sessionData
  [types.SET_PLACES](state, data) {
    state.places = data.places;
    state.rows = data.rows;
  },

  // set payment type from buy page
  [types.SET_PAYMENT_TYPE](state, data) {
    state.user.paymentType.push = data;
  },

  [types.GET_TOTAL_SUM](state) {
    state.totalSum = calculateCartSum(state.cart);
  },

  [types.CHANGE_PAYMENT_WITH_BONUSES](state, { force, bonuses }) {
    let totalSum = calculateCartSum(state.cart);

    let barBonuses = 0,
      ticketBonuses = 0,
      paymentWithBonuses = force ? true : !state.user.paymentWithBonuses;

    let diff = totalSum - bonuses;
    if (paymentWithBonuses) {
      if (diff < 0) {
        barBonuses = state.cart.bar.length
          ? state.cart.barSum - 1
          : state.cart.barSum;
        ticketBonuses = state.cart.tickets.length
          ? state.cart.ticketSum - 1
          : state.cart.ticketSum;
      } else {
        if (state.cart.barSum < state.cart.ticketSum) {
          let minBonuses = state.cart.barSum
            ? Math.ceil((state.cart.barSum / totalSum) * bonuses)
            : 0;
          minBonuses =
            state.cart.barSum && state.cart.barSum - minBonuses === 0
              ? minBonuses - 1
              : minBonuses;
          barBonuses = minBonuses;
          ticketBonuses = bonuses - minBonuses;
        } else {
          let minBonuses = state.cart.ticketSum
            ? Math.ceil((state.cart.ticketSum / totalSum) * bonuses)
            : 0;
          minBonuses =
            state.cart.ticketSum && state.cart.ticketSum - minBonuses === 0
              ? minBonuses - 1
              : minBonuses;
          barBonuses = bonuses - minBonuses;
          ticketBonuses = minBonuses;
        }
      }
    } else {
      barBonuses = 0;
      ticketBonuses = 0;
    }

    state.cart.totalSum = totalSum;
    state.user.paymentWithBonuses = paymentWithBonuses;
    state.cart.spentBonuses.bar = barBonuses;
    state.cart.spentBonuses.tickets = ticketBonuses;
    state.cart.usedBonuses = barBonuses + ticketBonuses;
    state.cart.sum = totalSum - (barBonuses + ticketBonuses);
  },

  // set payment type from buy page
  [types.UPDATE_PROP_VALUE](state, data) {
    state[data.stateObject][data.stateObjectProp] = data.value;
  },

  // get sessionId from SocketIO and set it to `user` in `state`
  SOCKET_user_session_id(state, data) {
    state.user.sessionId = data.userSessionId;
    state.user.socketSessionId = data.socketSessionId;
  },

  // get sessionId from DB and set it to `user` & `cart` in `state`
  [types.RESTORE_USER_DATA](state, data) {
    state.user = data.user;
    state.user.sessionEndAt = null;
    state.cart = data.cart;
  },

  [types.SET_USER_DATA](state, data) {
    if (data) {
      const {
        Birthday,
        Email,
        FullName,
        Gender,
        MobilePhone,
        CentralApiCrmSystems,
        CrmSystem,
      } = { ...data };

      state.user.name = FullName;
      state.user.email = Email;
      state.user.isAuthorized = true;
      state.user.birthday = Birthday;
      state.user.gender = Gender;
      state.user.phone = MobilePhone;
      state.user.centralCrmList = CentralApiCrmSystems;
      state.user.crmSystem = CrmSystem;
    }
  },

  [types.SET_USER_BALANCE](state, data) {
    state.user.card.balance = Math.floor(data.balance);
    state.user.card.id = data.id;
  },

  [types.CALCULATE_USER_MAX_BONUSES](state) {
    let currentCartSum = state.cart.totalSum || state.cart.sum;
    let maxBonuses =
      state.user.card.balance < currentCartSum
        ? state.user.card.balance
        : currentCartSum;

    if (currentCartSum <= maxBonuses) {
      if (state.cart.bar.length) {
        maxBonuses -= 1;
      }

      if (state.cart.tickets.length) {
        maxBonuses -= 1;
      }
    }

    state.user.maxBonuses = maxBonuses;
  },

  [types.SET_CUSTOMER_ACCOUNTS](state, accounts) {
    // Balance: 3460.9
    // BalancePreview: 0
    // Blocked: false
    // Deleted: false
    // Id: 813
    // Type: {Id: 1, Deleted: false, Name: "Бонусный", SystemType: "Bonuses"}
    // TypeId: 1

    const accountsInStore = accounts
      .filter((account) => account.Type.SystemType !== 'SpentFunds')
      .map((account) => {
        return {
          selected: false,
          picker: false,
          changed: false,
          discount: {
            max: {
              all: 0,
              bar: 0,
              tickets: 0,
            },
            bar: 0,
            tickets: 0,
            value: 0,
          },
          card_id: account.Id,
          id: account.Id,
          // id: account.Type.Id,
          balance: account.Balance,
          type: {
            id: account.Type.Id,
            name: account.Type.Name,
            systemType: account.Type.SystemType,
          },
          balancePreview: account.BalancePreview,
          blocked: account.Blocked,
          deleted: account.Deleted,
        };
      });

    state.customer.accounts = accountsInStore;
    state.customer.accountsList = accountsInStore.map((item, index) => index);
  },

  [types.SET_CUSTOMER_ACCOUNT](state, { accountId, data }) {
    // const account = this.getters.getAccountById(accountId);
    // const account = state.customer.accounts[accountId];

    state.customer.accounts = state.customer.accounts.map((account) => {
      console.log(account, accountId, data);

      return account.id === accountId ? { ...account, ...data } : account;
    });

    // state.customer.accounts[accountId] = { ...account, ...data };
  },

  [types.UNSELECT_CUSTOMER_ACCOUNTS](state) {
    state.customer.accountsList.forEach((index) => {
      state.customer.accounts[index].selected = false;
    });
  },

  [types.UNPICKED_CUSTOMER_ACCOUNTS](state) {
    state.customer.accountsList.forEach((index) => {
      state.customer.accounts[index].picker = false;
    });
  },
  [types.CUSTOMER_ACCOUNT_CALCULATE_BONUS_BALANCE](state, { accountId }) {
    let availableTicketDiscount = state.cart.ticketSum - 1;

    let account = state.customer.accounts[accountId];

    this.getters.selectedCustomerAccounts.forEach((account) => {
      if (account.id !== accountId) {
        availableTicketDiscount -= account.tickets;
      }
    });

    let calcTickets = Math.ceil(account.all / 2);
    let calcBar = account.all - calcTickets;

    if (calcTickets > availableTicketDiscount) {
      calcTickets = availableTicketDiscount;
      calcBar = account.all - availableTicketDiscount;
    }

    account.tickets = calcTickets;
    account.bar = calcBar;
  },

  [types.CALCULATE_CART](state) {
    console.log('CALCULATE_CART');

    const total = this.getters.total;
    state.cart.sum = total.all + Number(state.cart.donations);
    state.cart.usedBonuses = total.discount.all;
    state.cart.spentBonuses = {
      bar: total.discount.bar,
      tickets: total.discount.tickets,
    };
  },

  [types.SET_ORDER_INFO_AFTER_PAYMENT](state, payload) {
    state.orderInfo = payload;
  },

  [types.USER_REGISTRATION_FROM_WIDGET](state) {
    state.user.isRegistrationInWidget = true;
  },

  [types.SET_START_FROM_SCHEDULE](state) {
    state.isStartFromSchedule = true;
  },

  [types.SET_THEATRES](state, payload) {
    state.data.cities = payload.city;
    if (payload.city.length) {
      state.data.cities[0].Theatres = payload.theatres;
    }
  },

  [types.SET_DATA_FROM_GENERAL_SCHEDULE_BEFORE_UNMOUNTED](state, payload) {
    state.data.afterUnmountedGeneralSchedule = payload;
  },

  [types.SET_DATA_BAR](state, payload) {
    state.barAfterUmounted = payload;
  },

  [types.SET_PROMO_CODE_DATA](state, payload) {
    state.beforeCart = state.cart;
    state.cart = {
      ...state.cart,
      tickets: state.cart.tickets.map((ticket) => {
        const isPromo = payload.promoCodeData.MovieOrder.Places.find(
          (place) => place.Id === ticket.id,
        );

        if (!isPromo) return ticket;

        return { ...ticket, price: isPromo.FinalPrice };
      }),
    };
    state.cart.ticketSum = state.cart.tickets.reduce(
      (sum, acc) => acc.price + sum,
      0,
    );
    state.promoData = payload.promoCodeData;
    state.promoData.promoName = payload.promoName;
  },
  [types.CLEAR_PROMO_CODE_DATA](state) {
    state.cart = state.beforeCart;
    state.promoData = null;
  },
  [types.SET_TICKETS_SUM_HARDCODE](state, discount) {
    state.cart.ticketSum = state.cart.tickets.reduce(
      (sum, acc) => acc.price * (1 - discount / 100) + sum,
      0,
    );
  },
  [types.SET_PRIVACY_POLICY](state, payload) {
    state.theatre.PrivacyPolicyData = payload;
  },
  [types.SET_CURRENCY](state, payload) {
    state.setting.currency = payload;
  },
  [types.SET_THEATER_PRIVACY_DOCUMENTS](state, payload) {
    if(state.theatre){
      state.theatre.PrivacyPolicyData = payload.PrivacyPolicy;
      state.theatre.PrivacyConsentData = payload.PrivacyConsent;
    } else {
      state.theatre = { PrivacyPolicyData: payload.PrivacyPolicy, PrivacyConsentData: payload.PrivacyConsent};
    }
  }, 
  [types.SET_VK_WIDGET](state, isVkWidget) {
    state.isVkWidget = isVkWidget;
  },

  [types.SET_VK_MOBILE_WIDGET](state, isVkMobileWidget) {
    state.isVkMobileWidget = isVkMobileWidget;
  },
};

export default mutations;
